import { render, staticRenderFns } from "./EmployeeDeletedList.vue?vue&type=template&id=e1aeb154&"
import script from "./EmployeeDeletedList.vue?vue&type=script&lang=js&"
export * from "./EmployeeDeletedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports